import styled from 'styled-components';

export const CardContainer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 85px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin-bottom: 1rem;
`;

export const Progress = styled.div`
  width: 85px;
  padding: 10px;
`;

export const Line = styled.div`
  width: 1px;
  height: 60px;
  background-color: ${({ theme }) => theme.colors.themeColor};
`;

export const Body = styled.div`
  padding: 10px 12px;
  width: calc(100% - 30px);

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.title};
  }

  p {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const IconWrapper = styled.div`
  svg {
    fill: ${({ theme }) => theme.colors.title};
    stroke: ${({ theme }) => theme.colors.title};
  }
`;

export const ProgressbarWrapper = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;

  .external-bar {
    height: 6px;
    border-radius: 0 0 4px 4px;
  }
  .inner-bar {
    height: 6px;
    border-radius: 0 4px 4px 4px;
  }
`;
